/* React base class */
import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Router helper and shared utilities */
import { withRouter, utils } from "../helpers"

/* UI components */
import Icon from "../components/Icon"
import Logo from "../components/Logo"

/* Auth API: logout */
import { logout } from "../api/Auth"

/* Translation */
import { translate } from "../translates"

/* Widget Menu */
class Menu extends Component {

    componentDidMount = () => {
        document.body.style.overflow = "hidden"
    }

    componentWillUnmount = () => {
        document.body.style.overflow = ""
    }

    /* Draw Navigate */
    _navigate = (route) => {
        this.props.onClose()
        this.props.navigate(route)
    }

    /* Draw Logout */
    _logout = () => {
        if (this.props.token) {
            logout(this.props.token)
        }
        this.props.removeToken()
        this.props.removeUser()
        this.props.clearFavourites()
        this.props.onClose()
        this.props.navigate("/")
    }

    render = () => {
        /* Fields */
        const { user, city, lang, favourites } = this.props
        const favCount = Array.isArray(favourites) ? favourites.length : 0

        const nav = [
            { route: "/", label: translate("Главная"), icon: "pin" },
            { route: "/search", label: translate("Все услуги"), icon: "sliders" },
            { route: "/bookings", label: translate("Мои записи"), icon: "calendar" },
            { route: "/favourites", label: translate("Избранное"), icon: "heart", badge: favCount },
            { route: "/reviews", label: translate("Мои отзывы"), icon: "chat" },
            { route: "/profile", label: translate("Профиль"), icon: "user" }
        ]

        return (
            <div className="drawer" onClick={this.props.onClose}>
                <div className="drawer__panel" onClick={(e) => e.stopPropagation()}>
                    <div className="drawer__header">
                        {user ? (
                            <div className="drawer__user">
                                <span className="avatar">{user.avatar ? <img src={user.avatar} alt="" onError={utils.onAvatarError} /> : (user.name || "B")[0]}</span>
                                <div>
                                    <div className="drawer__user-name">{user.name}</div>
                                    <div className="drawer__user-phone">{user.phone}</div>
                                </div>
                            </div>
                        ) : (
                            <div className="drawer__user">
                                <Logo size={32} />
                            </div>
                        )}
                        <button className="modal__close" onClick={this.props.onClose} aria-label={translate("Закрыть")}>
                            <Icon name="close" size={20} />
                        </button>
                    </div>

                    <div className="drawer__body">
                        <div className="msearch" style={{ margin: "8px 4px 16px" }}>
                            <span className="msearch__icon"><Icon name="search" size={16} /></span>
                            <input className="msearch__input" placeholder={translate("Поиск услуг, организаций...")} onKeyDown={(e) => { if (e.key === "Enter") this._navigate("/search") }} />
                        </div>

                        <div className="drawer__group">
                            {nav.map((item) => (
                                <button key={item.route} className="drawer__item" onClick={() => this._navigate(item.route)}>
                                    <Icon name={item.icon} size={20} />
                                    <span>{item.label}</span>
                                    {item.badge > 0 ? (
                                        <span className="drawer__item-badge">{item.badge}</span>
                                    ) : (
                                        <Icon name="chevron_right" size={14} className="drawer__item-chev" />
                                    )}
                                </button>
                            ))}
                        </div>

                        <div className="drawer__group">
                            <div className="drawer__row">
                                <div className="drawer__row-label">
                                    <Icon name="globe" size={20} />
                                    <span>{translate("Язык")}</span>
                                </div>
                                <div className="drawer__lang">
                                    <button className={lang === "ru" ? "is-active" : ""} onClick={() => this.props.setLang("ru")}>RU</button>
                                    <button className={lang === "kk" ? "is-active" : ""} onClick={() => this.props.setLang("kk")}>KZ</button>
                                </div>
                            </div>
                            <button className="drawer__item" onClick={() => this._navigate("/notifications")}>
                                <Icon name="bell" size={20} />
                                <span>{translate("Уведомления")}</span>
                                <Icon name="chevron_right" size={14} className="drawer__item-chev" />
                            </button>
                        </div>

                        <div className="drawer__group">
                            <button className="drawer__item" onClick={() => this._navigate("/help")}>
                                <Icon name="headphones" size={20} />
                                <span>{translate("Помощь и поддержка")}</span>
                                <Icon name="chevron_right" size={14} className="drawer__item-chev" />
                            </button>
                            {user && (
                                <button className="drawer__item" onClick={this._logout} style={{ color: "var(--danger)" }}>
                                    <Icon name="user" size={20} />
                                    <span>{translate("Выйти")}</span>
                                </button>
                            )}
                        </div>
                    </div>

                    {!user && (
                        <div className="drawer__cta">
                            <button className="btn btn--block btn--lg" onClick={() => { this.props.onClose(); this.props.toggleAuth(true) }}>
                                {translate("Войти в Bookify")}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        token: state.token,
        user: state.user,
        city: state.city,
        lang: state.lang,
        favourites: state.favourites
    }
}

/* Map Dispatch To Props */
const mapDispatchToProps = dispatch => {
    return {
        toggleAuth: data => dispatch({ type: "TOGGLE_AUTH", payload: data }),
        setLang: data => dispatch({ type: "SET_LANG", payload: data }),
        removeToken: () => dispatch({ type: "REMOVE_TOKEN" }),
        removeUser: () => dispatch({ type: "REMOVE_USER" }),
        clearFavourites: () => dispatch({ type: "CLEAR_FAVOURITE" })
    }
}

/* Export */
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Menu))
